export type CountUnit = "values" | "percent";

export interface ChartRow {
	id: string;
	label: string;
	count: number;
	pct: number;
	color: string;
}

export interface SelectOption {
	value: string;
	label: string;
}

export const formatCount = (value: number, locale: string): string => value.toLocaleString(locale);

export const formatPct = (value: number, locale: string): string =>
	new Intl.NumberFormat(locale, { style: "percent", maximumFractionDigits: 1 }).format(value / 100);
